// extracted by mini-css-extract-plugin
export default {"root":"Navigation__root___XSUYJ","menuTitle":"Navigation__menuTitle____yFib","menuClosed":"Navigation__menuClosed___sjHUW"};